<template>
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="项目名称" prop="projectId">
              <el-select
                v-model="searchForm.projectId"
                style="width:100%"
              
                placeholder="请选择"
                @change="projectIdChange"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备名称" prop="phone">
              <el-input
                clearable
                v-model="searchForm.deviceName"
                placeholder="设备名称"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备类型" prop="deviceTypeId">
                <avue-input-tree  :props='treeDeviceTypeProps' style="width:100%;height:32px"  v-model="searchForm.deviceTypeId" placeholder="设备类型" type="tree" :dic="deviceTypeList"></avue-input-tree>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备编号" prop="deviceCode">
              <el-input
                clearable
                v-model="searchForm.deviceCode"
                placeholder="设备编号"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height:54px">
            <el-form-item label="检测日期" prop="name">
              <el-date-picker
                style="width:100%"
               
                v-model="searchForm.testTimeRound"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height:54px">
            <el-form-item label="有效期" prop="name">
              <el-date-picker
                style="width:100%"
               
                v-model="searchForm.expiryTimeRound"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <div style="float:right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
            新 增</el-button
          >
          <el-button type="primary" icon="el-icon-delete" size="small" @click="deleteRecord">
            删 除</el-button
          >
        </template>
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
        <template slot="orderAmount" slot-scope="scope">
          <div class="money" style="text-align: right;">
            <span>{{ tool.money_format_allowvoid(scope.row.orderAmount) }}</span>
          </div>
        </template>
        <template slot="deliveryTime" slot-scope="scope">
          <div>
            <span>{{ dayjs(scope.row.deliveryTime).format('YYYY-MM-DD') }}</span>
          </div>
        </template>
  
        <template slot="dishName" slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.dishName" placement="top">
            <div class="txtOver">{{ scope.row.dishName }}</div>
          </el-tooltip>
        </template>
        <template slot="description" slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.description" placement="top">
            <div class="txtOver">{{ scope.row.description }}</div>
          </el-tooltip>
        </template>
        <template slot="areaNameAndDeliveryAddress" slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.areaNameAndDeliveryAddress"
            placement="top"
          >
            <div class="txtOver">{{ scope.row.areaNameAndDeliveryAddress }}</div>
          </el-tooltip>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>
          <el-button
            type="text"
            size="small"
        
            @click="editRecord(scope.row)"
            >编辑
          </el-button>
          <el-button
            type="text"
            size="small"
         
            @click="deleteDevice(scope.row)"
            >删除
          </el-button>
        </template>
      </avue-crud>
     
      <hr-dialog
        :title="checkFormTittle"
        :allowFull="false"
        width="55%"
        :visible.sync="checkFormVisible"
      >
        <template slot="body">
          <RecordForm :model="formModel" :row="recordRow" v-if="checkFormVisible" @cancle="formCancle" @success="formSuccess">

          </RecordForm>
        </template>
      </hr-dialog>
 
    </basic-container>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import searchFromShow from '@/components/search-form-show/index';
import { treeByProjectDeviceTypeId } from '@/api/crmedical/device/device';
import {deviceTestPage,removeDeviceTestDetail} from "./index.js"
import RecordForm from "./deviceCheckRecord.vue"
import {  getBisDictData} from '@/api/common.js';
export default {
  components: { searchFromShow, RecordForm},
  data() {
    return {
      deviceUseTypeList:[],
      formModel:'add',
        checkFormTittle:"新增",
        checkFormVisible:false,
        deviceTypeList:[],
      recordRow: {},
      treeDeviceTypeProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      searchForm: {
        projectId: '',
        deviceName:'',
        deviceTypeId:'',
        deviceCode:'',
        testTimeRound:[],
        expiryTimeRound:[],
        startTestTime:'',
        endTestTime:'',
        startExpiryTime:"",
        endExpiryTime:''
      },
      projectList: [],
      option: {
        selection: true,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
        {
            label: '项目名称',
            prop: 'projectName',
          },
          {
            label: '设备名称',
            prop: 'deviceName',
          },
          {
            label: '设备类型',
            prop: 'deviceType',
          },
          {
            label: '设备编号',
            prop: 'deviceCode',
          },
          {
            label: '设备型号',
            prop: 'deviceModel',
          },

          {
            label: '生产厂家',
            prop: 'deviceProductionFactory',
          },
          {
            label: '所属部门',
            prop: 'deptName',
            hide:true
          },
          {
            label: '存放位置',
            prop: 'areaName',
            hide:true
          },
          {
            label: '设备用途',
            prop: 'useType',
          
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
        
            dicData:[]
          },
          {
            label: '检测结论',
            prop: 'testConclusion',
          },
          {
            label: '检测日期',
            prop: 'testTime',
            format: 'yyyy-MM-dd',
            type: "date",
          },
          {
            label: '有效期',
            prop: 'expiryTime',
            format: 'yyyy-MM-dd',
            type: "date",
          },
          {
            label: '检测费用',
            prop: 'testCost',
          },
          {
            label: '检测机构',
            prop: 'testInstitution',
          },
          {
            label: '合同名称',
            prop: 'contractName',
            hide:true
          }, {
            label: '合同编号',
            prop: 'contractCode',
            hide:true
          },
          {
            label: '备注',
            prop: 'description',
            hide:true
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],

    };
  },
  created() {
    this.initData();
   
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    deleteRecord() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            removeDeviceTestDetail({
        ids:this.recordIds.join(",")
      }).then(res=>{
        this.$message({
            type: 'success',
            message: '删除成功!'
          });
        this.onLoad()
      })
          })
          .then(() => {
            this.onLoad();
           
            this.$refs.crud.toggleSelection();
          });
      },
    formSuccess(){
      this.checkFormVisible = false
      this.onLoad()
    },
    formCancle(){
      this.checkFormVisible = false
    },
    viewRecord(row){
      this.recordRow = row
      this.checkFormTittle = "查看"
      this.formModel = "view"
      this.checkFormVisible = true
    },
    editRecord(row){
      this.recordRow = row
      this.checkFormTittle = "编辑"
      this.formModel = "edit"
      this.checkFormVisible = true
    },
    addRecord(){
        this.recordRow.projectId = this.searchForm.projectId
        this.formModel = "add"
        this.checkFormTittle = "新增"
        this.checkFormVisible = true
    },
    getDeviceTypeList(value) {
      this.deviceTypeFlag = false;
    
      treeByProjectDeviceTypeId({ projectId: value }).then((res) => {
        this.deviceTypeList = res.data;
        console.log('设备类型', this.deviceTypeList);
        this.deviceTypeFlag = true;
      });
      },
    selectionChange(val) {
      this.selectionList = val;
      this.recordIds = [];
      val.forEach((element) => {
        this.recordIds.push(element.id);
      });
      console.log(this.recordIds);
    },
    deleteDevice(row){
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeDeviceTestDetail({
        ids:row.id
      }).then(res=>{
        this.$message({
            type: 'success',
            message: '删除成功!'
          });
        this.onLoad()
      })
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },
    recordCancle() {
      
    },
    recordSuccess() {
     
      this.onLoad();
    },
    projectIdChange(projectId) {
      this.tool.clearObject(this.searchForm, 'projectId');
        this.getDeviceTypeList(projectId)
        getBisDictData({
        code: 'project_device_use_type',
        projectId: this.searchForm.projectId,
      }).then((res) => {
        this.findObject(
              this.option.column,
              'useType'
            ).dicData=res.data;
      });
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.testTimeRound && this.searchForm.testTimeRound.length > 0) {
        this.searchForm.startTestTime = this.dayjs(this.searchForm.testTimeRound[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.endTestTime = this.dayjs(this.searchForm.testTimeRound[1]).format(
          'YYYY-MM-DD 00:00:00'
        );
      } else {
        this.searchForm.testTimeRound = [];
        this.searchForm.startTestTime = '';
        this.searchForm.endTestTime = '';
      }
      if (this.searchForm.expiryTimeRound && this.searchForm.expiryTimeRound.length > 0) {
        this.searchForm.startExpiryTime = this.dayjs(this.searchForm.expiryTimeRound[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.endExpiryTime = this.dayjs(this.searchForm.expiryTimeRound[1]).format(
          'YYYY-MM-DD 00:00:00'
        );
      } else {
        this.searchForm.expiryTimeRound = [];
        this.searchForm.startExpiryTime = '';
        this.searchForm.endExpiryTime = '';
      }
      this.onLoad();
    },
    searchClear() {
      let canteenId = this.searchForm.canteenId;
      this.tool.clearObject(this.searchForm, 'projectId');
      this.searchForm.canteenId = canteenId;
    },
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    async initData() {
      await getProjectList().then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.$set(this.searchForm, 'projectId', this.projectList[0].id);
          this.getDeviceTypeList(this.searchForm.projectId);
          getBisDictData({
          code: 'project_device_use_type',
          projectId: this.searchForm.projectId,
        }).then((res) => {
          this.findObject(
              this.option.column,
              'useType'
            ).dicData=res.data;
          
        });
          this.onLoad()
        }
      });
    
    },

    
    onLoad() {
      this.loading = true;
      if (this.searchForm.projectId) {
      
        deviceTestPage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
  },
};
</script>